module.exports = __webpack_public_path__ + "img/logo_print.5ad538d9.png";